import Banner from "../Allcomponent/Banner"
import Cards from "../Allcomponent/cards"
import Shoes from "../Allcomponent/shoes"
function Shoess(){
    return(
        <>
        <Banner/>
        <Cards/>
        <Shoes/>
       
        </>
    )
}
export default Shoess